module.exports = __webpack_public_path__ + "img/po-article2-c1.66379e29.png";